import '../assets/css/styles.scss';
import React from 'react';
import { Helmet } from 'react-helmet';

import Footer from '../components/footer/footer'
import NavigationMenu from '../components/menu/menu'
import AboutProjectSection from '../components/sections/about-project/about-project'
import ContactSection from '../components/sections/contact/contact'
import DocumentsSection from '../components/sections/documents/documents'
import HomeSection from '../components/sections/home/home'
import SprintsSection from '../components/sections/sprints/sprints'
import TeamSection from '../components/sections/team/team'

// import HomeSection from '../components/sections/home/home';
const IndexPage = () => (
  <div>
    <Helmet>
      <meta charSet="utf-8" />
      <title>GridBox | PowerPlayers team</title>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
    </Helmet>
    <NavigationMenu />
    <HomeSection />
    <AboutProjectSection />
    <TeamSection />
    <SprintsSection></SprintsSection>
    <DocumentsSection />
    <ContactSection />
    <Footer />
  </div>
)

export default IndexPage
